import {IoMdPricetag} from "react-icons/io";

import {Chip} from "@/components/chip/Chip.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";

import styles from "./Tag.module.scss";

interface TagProps {
  text?: string;
  iconColor?: string;
}

export const Tag = ({text, iconColor}: TagProps) => {
  return (
    <Chip variant={"tag"} size={"smallLight"} className={styles.tag}>
      <Icon icon={IoMdPricetag} style={{color: iconColor}} size={"chip"} />
      <Tooltip tooltipContent={text} delayMs={500}>
        <div className={"ellipsis-overflow"}>{text}</div>
      </Tooltip>
    </Chip>
  );
};
